/**
 * @generated SignedSource<<b82e9efeceecabb3b26a1ad4543b460b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ConnectInboxAudience = "CUSTOMERS" | "EMPLOYEES";
import { FragmentRefs } from "relay-runtime";
export type ConnectAdminScreenInboxListItem_inbox$data = {
  readonly audience: ConnectInboxAudience | null;
  readonly customTitle: string | null;
  readonly id: string;
  readonly tags: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"TodoToolbarButtonTags_tags">;
  }>;
  readonly teams: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"DialogButtonTeams_teams">;
  }>;
  readonly todoCategory: {
    readonly title: string;
  } | null;
  readonly " $fragmentType": "ConnectAdminScreenInboxListItem_inbox";
};
export type ConnectAdminScreenInboxListItem_inbox$key = {
  readonly " $data"?: ConnectAdminScreenInboxListItem_inbox$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConnectAdminScreenInboxListItem_inbox">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConnectAdminScreenInboxListItem_inbox",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "audience",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategory",
      "kind": "LinkedField",
      "name": "todoCategory",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DialogButtonTeams_teams"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategoryTag",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TodoToolbarButtonTags_tags"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ConnectInbox",
  "abstractKey": null
};
})();

(node as any).hash = "3b7a54830ca11f1fa1f8f4966a8768aa";

export default node;
